export default __webpack_public_path__ + "static/iam_policy_02-a893594c99e644100a779cbf8c58967a.png";